<template>
  <h1>Login to Webareal</h1>
</template>

<script setup lang="ts">
// import { onMounted } from 'vue';
// import { useRouter } from 'vue-router';
// import { v4 as uuidv4 } from 'uuid';
// import { STATE_KEY } from './webareal';

// const WEBAREAL_AUTH_URL = 'https://marketplace.webareal.cz/user-auth';
// const CLIENT_ID = '0PPI0kqno2HNaoAXdlwGrai';
// const REDIRECT_URI = `${window.location.origin}/integrations/webareal/callback`;

// onMounted(() => {
//   const state = uuidv4(); // CSRF protection
//   localStorage.setItem(STATE_KEY, state);

//   const params = new URLSearchParams({
//     client_id: CLIENT_ID,
//     redirect_uri: REDIRECT_URI,
//     response_type: 'code',
//     scope: 'USER_INFO',
//     state,
//   });

//   window.location.href = `${WEBAREAL_AUTH_URL}?${params.toString()}`;
// });
</script>
